/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { IoDuplicate } from 'react-icons/io5';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import createDecorator from 'final-form-focus';
import FormFieldsGenerator from '../../../../../../../shared/FormFieldsGenerator';

// Create focus decorator for automatic focus on validation errors
const focusOnError = createDecorator();

const DuplicateSingleItemModal = ({
  open,
  onClose,
  onConfirm,
  originalItem,
  template,
  controlledVocab,
  currentItemsCount = 0,
}) => {
  const formRef = useRef();
  const renderFooter = (
    handleSubmit,
    pristine,
    submitting,
    hasValidationErrors,
  ) => {
    return (
      <ModalFooter>
        <Button
          buttonStyle="primary"
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          disabled={submitting}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.duplicateSingleItemModal.duplicate"
            defaultMessage="Duplicate Item"
          />
        </Button>
        <Button onClick={onClose}>
          <FormattedMessage
            id="ui-plugin-inventory-templates.modal.cancel"
            defaultMessage="Cancel"
          />
        </Button>
      </ModalFooter>
    );
  };

  // Let FormFieldsGenerator handle validation based on template requirements

  const onHandleSubmit = (values, form) => {
    onConfirm(values);
    onClose();
  };

  // Prepare initial values from original item with next copy number
  const initialValues = {
    ...originalItem,
    barcode: '', // Clear barcode for new item
    itemHrid: '', // Clear HRID for new item
    copyNumber: currentItemsCount + 1, // Set next sequential copy number
  };

  // Use template as-is to preserve all field requirements and validation rules
  const preparedTemplate = template?.templateFields?.items;

  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      decorators={[focusOnError]}
      mutators={{
        ...arrayMutators,
      }}
      subscription={{
        handleSubmit: true,
        pristine: true,
        submitting: true,
        hasValidationErrors: true,
      }}
    >
      {({ handleSubmit, pristine, submitting, hasValidationErrors }) => {
        return (
          <Modal
            open={open}
            onClose={onClose}
            footer={renderFooter(
              handleSubmit,
              pristine,
              submitting,
              hasValidationErrors,
            )}
            wrappingElement="form"
            label={
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '7px',
                }}
              >
                <IoDuplicate size={18} />
                <FormattedMessage
                  id="ui-plugin-inventory-templates.duplicateSingleItemModal.label"
                  defaultMessage="Duplicate Item"
                />
              </div>
            }
            size="large"
          >
            <form onSubmit={handleSubmit}>
              <div style={{ padding: '16px' }}>
                <div
                  style={{
                    marginBottom: '16px',
                    padding: '12px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #dee2e6',
                    borderRadius: '4px',
                  }}
                >
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.duplicateSingleItemModal.description"
                    defaultMessage="Edit the item details below. The barcode field is required and must be unique."
                  />
                </div>

                <FormFieldsGenerator
                  key="edit-single-item"
                  formValues={preparedTemplate}
                  controlledVocab={controlledVocab}
                />
              </div>
            </form>
          </Modal>
        );
      }}
    </Form>
  );
};

DuplicateSingleItemModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  originalItem: PropTypes.object.isRequired,
  template: PropTypes.object,
  controlledVocab: PropTypes.object,
  currentItemsCount: PropTypes.number,
};

export default DuplicateSingleItemModal;
